module.exports = __webpack_public_path__ + "img/Copyright_pic09.8b521df9.jpg";